import {BasicService} from './basic.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_DETENTION_URL } from '../../connection.data';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class DetentionService extends BasicService {

    constructor(http: HttpClient){
        super(http);
        this.baseUrl = API_DETENTION_URL;
    }

    getByPeriod(st, et): Observable<any[]>{
        const stStr = encodeURIComponent(st.toLocaleString('sv'));
        const etStr = encodeURIComponent(et.toLocaleString('sv'));
        var url = `${API_DETENTION_URL}/period?st=${stStr}&et=${etStr}`;

        console.log(url);
        return this.http.get<any>(url).pipe(
            map((response)=>{
                if(response.status=='error'){return []}
                return response.rows
            })
        )
    }

}
